/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-fragments */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { Component } from 'react';
import ResetPasswordForm from './ResetPasswordForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import { Auth } from 'aws-amplify';
import { withTranslation } from 'react-i18next';
import AWS from 'aws-sdk';
import UserService from '../../../Service/UserService';

const APPLICATION_EXCEPTION = window.ApplicationException;
const APP_STRING = window.AppStrings;

class ForgotPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_authError: '',
			_isForgotPassScrnOpen: true,
			_isLoading: false,
			_userPhone: '',
			_otpMode: APP_STRING.PHONE_NUMBER,

			_alert: {
				_show: false,
				_message: '',
				_severity: ''
			}
		};
	}

	resetAuthError = () => {
		this.setState({
			_authError: ''
		});
	};

	resetPassword = async passwordResetDetail => {
		this.setState({
			_isLoading: true
		});
		try {
			await Auth.forgotPasswordSubmit(
				this.state._userPhone,
				passwordResetDetail.otp,
				passwordResetDetail.password
			);
			await this.showAlert(true, 'success', this.props.t('profile.password_successfully_sent'));
			this.setState({
				_isLoading: false
			});
			setTimeout(() => {
				this.redirectToLoginScreen();
			}, 2000);
		} catch (error) {
			this.setState({
				_isLoading: false
			});
			if (error.code === APPLICATION_EXCEPTION.CODE_MIS_MATCH_EXCEPTION) {
				this.setState({
					_authError: this.props.t('error_message.invalid_code')
				});
			} else {
				this.setState({
					_authError: error.message
				});
			}
		}
	};

	verifyPhoneIfExist = async phone => {
		this.setState({
			_isLoading: true
		});
		try {
			const res = await UserService.getUserByPhone(phone);
			if (res) {
				this.setState({
					_isLoading: false
				});
				return res;
			}
		} catch (err) {
			this.setState({
				_authError: err,
				_isLoading: false
			});
		}
	};

	forgotPassword = async phone => {
		this.setState({
			_userPhone: phone,
			_isLoading: true
		});

		try {
			const resp = await Auth.forgotPassword(phone);
			this.redirectToResetPassword(resp.CodeDeliveryDetails.AttributeName);
		} catch (error) {
			this.setState({
				_isLoading: false
			});
			if (
				error.code === APPLICATION_EXCEPTION.USER_NOT_FOUND_EXCEPTION ||
				error.code === APPLICATION_EXCEPTION.INVALID_PARAMETER_EXCEPTION
			) {
				this.setState({
					_authError: 'forgot_password.invalid_parameter_exception_message'
				});
			} else {
				this.setState({
					_authError: error.message
				});
			}
		}
	};

	redirectToResetPassword = mode => {
		this.setState({
			_isLoading: false,
			_isForgotPassScrnOpen: false,
			_otpMode: mode === APP_STRING.PHONE_NUMBER ? APP_STRING.MOBILE_NUMBER : mode
		});
	};

	redirectToLoginScreen = () => {
		this.props.openSignInForm();
	};

	showAlert = async (show, severity, message) => {
		const alert = {
			_show: show,
			_message: message,
			_severity: severity
		};
		await this.setState({
			_alert: alert
		});
	};

	hideAlert = async () => {
		const alert = {
			_show: false,
			_message: '',
			_severity: ''
		};
		await this.setState({
			_alert: alert
		});
	};

	render() {
		if (this.state._isForgotPassScrnOpen) {
			return (
				<ForgotPasswordForm
					verifyPhoneIfExist={this.verifyPhoneIfExist}
					alert={this.state._alert}
					authError={this.state._authError}
					hideAlert={this.hideAlert}
					isLoading={this.state._isLoading}
					onForgot={this.forgotPassword}
					openSignInForm={this.props.openSignInForm}
					resetAuthError={this.resetAuthError}
				/>
			);
		} else {
			return (
				<ResetPasswordForm
					alert={this.state._alert}
					authError={this.state._authError}
					hideAlert={this.hideAlert}
					isLoading={this.state._isLoading}
					mode={this.state._otpMode}
					onReset={this.resetPassword}
					resetAuthError={this.resetAuthError}
				/>
			);
		}
	}
}

export default withTranslation()(ForgotPassword);
